module.exports = __webpack_public_path__ + "static/media/sale_off.2d69dfbc.png";